import { Layer } from './layer';

import WMTS from 'ol/source/WMTS';
import TileLayer from 'ol/layer/Tile';
import WMTSTileGrid from 'ol/tilegrid/WMTS.js';

import TileDebug from 'ol/source/TileDebug.js';

class WMTSLayer extends Layer {
	
	constructor(source, layer) {
		super(layer);
		this.source = source;
	}
	
	updateLayer(url, requestEncoding, layerName, style, matrixSet, tileGrid) {		
		let format = undefined;
		if( requestEncoding == 'KVP' ) {
			format = 'image/png';
		}
		
		this.source = new WMTS({
			url: url,
			requestEncoding: requestEncoding,
			format: format,
			layer: layerName,
			style: style,
			matrixSet: matrixSet,
			tileGrid: tileGrid
		});

		this.layer.setSource(this.source);
	}

	setLoadingError(message) {
		this.source = new TileDebug({
			template: message
		});
		
		this.layer.setSource(this.source);
	}
}

const wmtsTileGrid = (origins, resolutions, matrixIds, extent) => {
	return new WMTSTileGrid({
		origins: origins,
		resolutions: resolutions,
		matrixIds: matrixIds,
		extent: extent		
	});
};

const wmts = () => {	
    const layer = new TileLayer({
    	source: undefined
    });
    
    return new WMTSLayer(undefined, layer);
}

export { wmts, wmtsTileGrid, WMTSLayer }